import { postRequest } from "api/tools/httpRequests";
import { AxiosResponse } from "axios";
import { IJSONResponse } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/types";

export class ActivityCartService {
  static async updateCartStatus(props: { cartId: number; status: string }) {
    try {
      const response: AxiosResponse<IJSONResponse> = await postRequest(
        "activities/cart/updateCartStatus",
        {
          cartId: props.cartId,
          status: props.status,
        }
      );

      if (response.data.success) {
        return response.data.success;
      } else {
        throw new Error(
          response.data.errorMessage || "Failed to update status"
        );
      }
    } catch (error) {
      throw error;
    }
  }

  static async updateCartRemarks(props: { cartId: number; remarks: string }) {
    try {
      const response: AxiosResponse<IJSONResponse> = await postRequest(
        "activities/cart/updateRemarks",
        {
          cartId: props.cartId,
          remarks: props.remarks,
        }
      );

      if (response.data.success) {
        return response.data.success;
      } else {
        throw new Error(
          response.data.errorMessage || "Failed to update remarks"
        );
      }
    } catch (error) {
      throw error;
    }
  }

  static async updateCartUserId(props: { cartId: number; userId: string }) {
    try {
      const response: AxiosResponse<IJSONResponse> = await postRequest(
        "activities/cart/updateUserId",
        {
          cartId: props.cartId,
          userId: props.userId,
        }
      );

      if (response.data.success) {
        return response.data.success;
      } else {
        throw new Error(
          response.data.errorMessage || "Failed to update userId"
        );
      }
    } catch (error) {
      throw error;
    }
  }
}
